/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuperSearchCapTableVersionResult } from './SuperSearchCapTableVersionResult';
import type { SuperSearchCompanyResult } from './SuperSearchCompanyResult';
import type { SuperSearchCustomViewResult } from './SuperSearchCustomViewResult';
import type { SuperSearchDocumentResult } from './SuperSearchDocumentResult';
import type { SuperSearchFinancialStatementVersionResult } from './SuperSearchFinancialStatementVersionResult';
import type { SuperSearchFirmResult } from './SuperSearchFirmResult';
import type { SuperSearchMeasurementDateResult } from './SuperSearchMeasurementDateResult';
import type { SuperSearchPageResult } from './SuperSearchPageResult';
import type { SuperSearchValuationApproachResult } from './SuperSearchValuationApproachResult';
import type { SuperSearchValuationVersionResult } from './SuperSearchValuationVersionResult';
import type { SuperSearchWaterfallViewResult } from './SuperSearchWaterfallViewResult';
export type SuperSearchResult = {
  id: string;
  type: SuperSearchResult.type;
  label: string;
  subtitle: string;
  path: string;
  search_text: string;
  firm: SuperSearchFirmResult;
  company?: SuperSearchCompanyResult;
  page?: SuperSearchPageResult;
  measurement_date?: SuperSearchMeasurementDateResult;
  document?: SuperSearchDocumentResult;
  cap_table_version?: SuperSearchCapTableVersionResult;
  financial_statement_version?: SuperSearchFinancialStatementVersionResult;
  valuation_version?: SuperSearchValuationVersionResult;
  valuation_approach?: SuperSearchValuationApproachResult;
  waterfall_view?: SuperSearchWaterfallViewResult;
  custom_view?: SuperSearchCustomViewResult;
};
export namespace SuperSearchResult {
  export enum type {
    FIRM = 'firm',
    FIRM_PAGE = 'firm_page',
    COMPANY = 'company',
    COMPANY_PAGE = 'company_page',
    MEASUREMENT_DATE = 'measurement_date',
    DOCUMENT = 'document',
    CAP_TABLE_VERSION = 'cap_table_version',
    FINANCIAL_STATEMENT_VERSION = 'financial_statement_version',
    VALUATION_VERSION = 'valuation_version',
    VALUATION_APPROACH = 'valuation_approach',
    WATERFALL_VIEW = 'waterfall_view',
    CUSTOM_VIEW = 'custom_view',
  }
}

